import store from "@frameworks/web/redux/store";
import { GUEST_VALIDATE_MPIN, GUEST_VALIDATE_MPIN_ERROR, GUEST_VALIDATE_MPIN_HIDE_ERROR, GUEST_VALIDATE_MPIN_START_LOADER, GUEST_VALIDATE_MPIN_STOP_LOADER, } from "../interface/iGuestValidateMPIN";
class GuestValidateMPINActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    GuestValidateMPIN(data) {
        this.dispatch({
            type: GUEST_VALIDATE_MPIN,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: GUEST_VALIDATE_MPIN_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: GUEST_VALIDATE_MPIN_HIDE_ERROR,
        });
    }
    GuestValidateMPINloader() {
        this.dispatch({
            type: GUEST_VALIDATE_MPIN_START_LOADER,
        });
    }
    GuestValidateMPINStopLoader() {
        this.dispatch({
            type: GUEST_VALIDATE_MPIN_STOP_LOADER,
        });
    }
}
export default GuestValidateMPINActions;
